import { catchError, filter, switchMap } from 'rxjs/operators';
import { concat, of } from 'rxjs';
import axios from 'axios-observable';
import { format } from 'date-fns';
import { PayloadEpic } from '@/store/epics/epic-types';
import { actions, asyncActions } from '@/store/slices';
import { apiEndpoints } from '@/store/constants';
import { AssetLotModel } from '@/models';
import { UpdateExpirationDatePayload } from '@/store/slices/payload-types/asset-payload-types';

export const changeExpirationDateEpic: PayloadEpic<UpdateExpirationDatePayload, AssetLotModel> = (action$) => {
    return action$.pipe(
        filter(asyncActions.assetLots.changeExpirationDate.match),
        switchMap(({ payload }) =>
            concat(
                of(actions.assetLots.setIsSaving(true)),
                changeExpirationDate(payload).pipe(
                    switchMap(({ data }) => [
                        actions.assetLots.upsertOne(data),
                        actions.assetLots.setSavingErrors(null),
                    ]),
                    catchError((error) => {
                        console.error('changeExpirationDateEpic', error);
                        return of(actions.assetLots.setSavingErrors(error));
                    })
                ),
                of(actions.assetLots.setIsSaving(false))
            )
        )
    );
};

const changeExpirationDate = (payload: UpdateExpirationDatePayload) => {
    return axios.post<AssetLotModel>(apiEndpoints.changeExpirationDate(payload.assetLotUid), {
        expiration_date: format(payload.expiration_date, 'yyyy-MM-dd'),
    });
};
